import { __assign, __extends, __rest } from "tslib";
import React from 'react';
import { Async } from 'react-select';
import { getComponents } from './components';
var SelectAsync = /** @class */ (function (_super) {
    __extends(SelectAsync, _super);
    function SelectAsync() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.components = getComponents('wide');
        return _this;
    }
    SelectAsync.prototype.render = function () {
        var _a = this.props, innerRef = _a.innerRef, props = __rest(_a, ["innerRef"]);
        return (React.createElement(Async, __assign({}, props, { ref: innerRef, controlShouldRenderValue: true, openMenuOnClick: true, openMenuOnFocus: true, menuPortalTarget: document.body, menuPosition: "fixed", components: this.components })));
    };
    return SelectAsync;
}(React.Component));
export default SelectAsync;
//# sourceMappingURL=SelectAsync.js.map